import NoteCard from "@/components/NoteCard";
import SubscribeButton from "@/components/SubscribeButton";
import WelcomeCard from "@/components/WelcomeCard";
import { useNotes } from "@/services/hooks";
import { ArrowForwardIos } from "@mui/icons-material";
import { Box, IconButton, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";

export default function NotesContainer({ artistKey }) {
  const navigate = useNavigate();
  const { data: artistContent } = useNotes(artistKey);

  return (
    <Box
      id="notes"
      sx={{
        // background:
        //   "linear-gradient(180deg, rgba(36,36,36,1) 0%, rgba(18,18,18,0) 50%)",
        py: 4,
        px: 2,
      }}
      style={{ marginTop: "-10px" }}
    >
      <Box
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Typography
          variant="h6"
          sx={{ mt: 2, mb: 2, fontWeight: 800 }}
          // color="secondary"
        >
          Artist Notes
        </Typography>
        <IconButton onClick={() => navigate(`/${artistKey}/notes`)}>
          <ArrowForwardIos />
        </IconButton>
      </Box>

      <WelcomeCard artistKey={artistKey} />
      {/* <SubscribeButton artistKey={artistKey} /> */}

      {artistContent?.slice(0, 3).map((content, index) => (
        <Box key={index}>
          <NoteCard content={content} />
        </Box>
      ))}

      {artistContent?.length > 3 && (
        <Box
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
          onClick={() => navigate(`/${artistKey}/notes`)}
        >
          <Typography variant="body1" color="darkgray">
            {`View ${artistContent.length - 3} more notes`}
          </Typography>
          <ArrowForwardIos
            style={{ fontSize: "15px", color: "darkgray" }}
            sx={{ ml: 2 }}
          />
        </Box>
      )}
    </Box>
  );
}
